<template>
  <div class="personal">
    <Nav />
    <div style="height: 80px"></div>
    <div class="personal-bottom">
      <!-- <div class="personal-bottom-top">
                <div class="personal-bottom-top-div"><div class="personal-bottom-top-div-div"></div><span style="margin-left:25px;">个人中心</span></div>
            </div> -->
      <div class="personal-bottom-bottom">
        <div class="personal-bottom-bottom-left">
          <slide @change="changeSlide"></slide>
        </div>
        <div class="personal-bottom-bottom-right">
          <div class="personal-bottom-bottom-right-top">
            <div>我的位置：</div>
            <el-breadcrumb
              class="daohang"
              separator-class="el-icon-arrow-right"
            >
              <el-breadcrumb-item class="xinxi" :to="{ path: '/personalc?id=0&tab=0' }">
                <span>我的信息</span>
              </el-breadcrumb-item>
              <el-breadcrumb-item
                class="xinxi"
              >
                <span>修改手机号</span>
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="personal-bottom-bottom-right-bottom">
            <div class="update_userinfoBox">
              <div class="item_input_name">
                <div class="name">手机验证</div>
                <div class="phone_input">
                  <input
                    v-model="mobile"
                    type="text"
                    maxlength="11"
                    placeholder="请输入旧手机号"
                  />
                </div>
              </div>
              <div class="item_input_name">
                <div class="name">验证码</div>
                <div class="phone_input">
                  <input
                    v-model="token"
                    maxlength="10"
                    type="text"
                    placeholder="请输入验证码"
                  />
                </div>

                <div v-show="botton1" @click="Token" class="getCodes">
                  获取验证码
                </div>
                <div v-show="botton2" class="getCodes_nums">
                  {{ btnTitle }}
                </div>
              </div>
              <div @click="Tijiao" class="btn_next">下一步</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-show="tishi1"
      style="
        position: absolute;
        top: calc(50% - 142px / 2);
        left: calc(50% - 248px / 2);
        text-align: center;
        height: 142px;
        border-radius: 6px;
        background-color: rgba(255, 255, 255, 1);
        width: 248px;
      "
    >
      <img style="margin-top: 30px" src="https://oss.ansongqiubo.com/assets/cuowu2.png" alt="" />
      <div style="margin-top: 20px">手机号错误</div>
    </div>
  </div>
</template>

<script>
import Nav from "../component/Nav.vue";
import slide from './template_slide.vue'

import qs from "qs";
export default {
  name: "App",
  data() {
    return {
      b: 0,
      mobile: "",
      token: "",
      botton1: true,
      botton2: false,
      btnTitle: "60s",
      tishi1: false,
      activeName: 0,
    };
  },
  methods: {
    changeSlide(data){
      this.$router.push(data);
    },
    Mingcheng(e, i) {
      console.log(e, i);
      if (e == 0 && i == 0) {
        this.$router.push("/personalc");
      }
      if (e == 0 && i == 1) {
        this.$router.push("/wodeguanzhu");
      }
      if (e == 0 && i == 2) {
        this.$router.push("/wodefensi");
      }
      if (e == 0 && i == 3) {
        this.$router.push("/lishiguankan");
      }
      if (e == 0 && i == 4) {
        this.$router.push("/wodezichan");
      }
      if (e == 0 && i == 5) {
        this.$router.push("/wodexinxi");
      }
      if (e == 1 && i == 0) {
        this.$router.push("/shezhiguanliyuan");
      }
      if (e == 1 && i == 1) {
        this.$router.push("/guanlijinyan");
      }
      if (e == 1 && i == 2) {
        this.$router.push("/tianjiazhiboyuan");
      }
      if (e == 2 && i == 0) {
        this.$router.push("/wodeshouyi");
      }
      if (e == 2 && i == 1) {
        this.$router.push("/yonghupaihangbang");
      }
      // if (e == 3&&i == 0) {
      //     this.$router.push('/shipinfabu')
      // }
      // if (e == 3&&i == 1) {
      //     this.$router.push('/ziyuanguanli')
      // }
      if (e == 3 && i == 0) {
        this.$router.push("/zhiboshuju");
      }
      // if (e==4&&i==1) {
      //     this.$router.push('/shipinshuju')
      // }
    },
    dianji(e) {
      this.b = e;
    },
    Token() {

      if(this.$route.query.mobile != this.mobile){
        return this.$message.error('请输入原手机号！');
      }
      let reg = /^1[23456789]\d{9}$/;
      if (!reg.test(this.mobile)) {
        this.$message({
          message: "请输入正确的手机号",
          type: "warning",
        });
        return;
      }
      this.$axios({
        headers: {
          device: "web",
          packageId: "1",
          version: "1.0.0",
          channel: "web",
          "authToken": localStorage.getItem("token"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
        transformRequest: [
          function (data) {
            data = qs.stringify(data);
            console.log(data);
            return data;
          },
        ],
        url: this.api + "/v1/profile/sendOriginMobileSmsCode",
        method: "post",
        data: {
          mobile: this.mobile,
        },
      }).then((res) => {
        if (res.data.message == "success") {
          this.botton1 = false;
          this.botton2 = true;
          if (this.botton2 == true) {
            let time = 60;
            let timer = setInterval(() => {
              if (time == 0) {
                clearInterval(timer);
                this.botton1 = true;
                this.botton2 = false;
              } else {
                this.btnTitle = time + "s";
                this.disabled = true;
                time--;
              }
            }, 1000);
          }
        } else {
          this.tishi1 = true;
          setTimeout(() => {
            this.tishi1 = false;
          }, 2000);
        }
        console.log(res);
      });
    },
    Tijiao() {
      if(this.$route.query.mobile != this.mobile){
        return this.$message.error('请输入原手机号！');
      }
      let reg = /^1[23456789]\d{9}$/;
      if (!reg.test(this.mobile)) {
        this.$message({
          message: "请输入正确的手机号",
          type: "warning",
        });
        return;
      }

      if (!this.token || this.token.trim().length == 0 ) {
        this.$message({
          message: "请输入验证码",
          type: "warning",
        });
        return;
      }
      this.$axios({
        headers: {
          device: "web",
          packageId: "1",
          version: "1.0.0",
          channel: "web",
          "authToken": localStorage.getItem("token"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
        transformRequest: [
          function (data) {
            data = qs.stringify(data);
            console.log(data);
            return data;
          },
        ],
        url: this.api + "/v1/profile/checkOriginMobileSmsCode",
        method: "post",
        data: {
          mobile: this.mobile,
          token: this.token,
        },
      }).then((res) => {
        console.log(res);
        if (res.data.message !== "success") {
          this.$message({
            message: "验证码错误",
            type: "warning",
          });
        } else {
          this.$router.push({
            path: "/bangdingshoujihao",
            query: { mobile: this.mobile, token: this.token },
          });
        }
      });
    },
  },
  components: {
    Nav,slide
  },
};
</script>

<style scoped lang='scss'>
.personal-bottom-bottom-left .el-collapse-item__header {
  box-sizing: border-box;
  padding-left: 20px;
  background-color: #fff;
  border-bottom: 0px solid #ebeef5;
  color: #333;
}
.personal-bottom-bottom-left .is-active {
  color: rgba(114, 30, 220, 1);
}

.personal {
  width: 100vw;
  background: #f7f8fa;
  .xzcxzcxz {
    color: rgba(114, 30, 220, 1) !important;
  }
  .personal-bottom {
    background-color: #f7f8fa;
  }
  .personal-bottom-top {
    width: 100%;
    height: 60px;
    min-width: 1240px;
    background-color: #fff;
  }
  .personal-bottom-top-div {
    width: 1240px;
    height: 60px;
    margin: 0 auto;
    color: #333;
    font-size: 23px;
    line-height: 60px;
    display: flex;
    align-items: center;
  }
  .personal-bottom-top-div-div {
    width: 6px;
    height: 50px;
    background-color: #721edc;
    border-radius: 6px;
  }
}

.personal-bottom-bottom {
  width: 1200px;
  height: calc(100vh - 105px);
  margin: 0 auto;
  display: flex;
  background-color: #f7f8fa;
  min-width: 1200px;
  .personal-bottom-bottom-left {
    width: 190px;
    height: 100%;
    background-color: #fff;
    margin-top: 16px;
    color: #333;
    .myel-collapse-item {
      width: 190px;
    }
    .prent_item {
      text-align: center;
      width: 100%;
      height: 100%;
      display: flex;
      .parent_icon {
        display: flex;
        align-items: center;
      }
      .parent_name {
        display: flex;
        align-items: center;
        font-size: 14px;
      }
    }
    .child_item {
      color: #a6a6a6;
      width: 100%;
      height: 52px;
      line-height: 52px;
      background-color: #f2f2f2;
      .child_img {
        display: flex;
        align-items: center;
      }
      .child_name {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}

.personal-bottom-bottom-right {
  flex: 2;
  margin-left: 12px;
  height: 100%;
  max-width: 998px;
  background-color: #fff;
  padding: 30px 20px;
  box-sizing: border-box;
  margin-top: 16px;
  .personal-bottom-bottom-right-top {
    background-color: #fff;
    display: flex;
    align-items: center;
  }

  .personal-bottom-bottom-right-top-left {
    width: 8px;
    height: 100%;
    background-color: #721edc;
  }
  .personal-bottom-bottom-right-top > span {
    /* width: 8px;
    height: 53px; */
    color: white;
    margin-left: 20px;
    font-size: 24px;
  }
}

.personal-bottom-bottom-right-bottom {
  height: calc(94% - 15px);
  margin-top: 15px;
  padding: 20px;
  position: relative;
  box-sizing: border-box;
}
.update_userinfoBox {
  display: flex;
  flex-direction: column;
  .btn_next {
    cursor: pointer;
    width: 130px;
    align-self: center;
    margin-top: 100px;
    height: 36px;
    background: #b3b3b3;
    border-radius: 4px;
    text-align: center;
    line-height: 36px;

    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
  }
  .btn_next:hover{
      background: #721edc;
      transition: all .3s;
  }
  .item_input_name {
    margin-top: 16px;
    display: flex;
    align-items: center;
    .name {
      min-width: 86px;
      margin-right: 30px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #333333;
    }
    .phone_input {
      width: 230px;
      height: 36px;
      background: #f7f8fa;
      border-radius: 4px;
      input {
        box-sizing: border-box;

        outline-style: none;
        border: none;
        width: 230px;
        height: 36px;
        background: #f7f8fa;
        border-radius: 4px;
        padding: 0 10px;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
      }
    }
    .getCodes_nums {
      margin-left: 14px;
      cursor: pointer;
      width: 130px;
      text-align: center;
      height: 36px;
      line-height: 36px;
      background: #b3b3b3;
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
    .getCodes {
      margin-left: 14px;
      cursor: pointer;
      width: 130px;
      height: 36px;
      background: #721edc;
      border-radius: 4px;
      text-align: center;
      line-height: 36px;
      color: #ffffff;
      font-size: 14px;
      .btntxt {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }
}
.daohang {
  display: flex;
  color: white;
  width: 500px;
  //   margin-left: 20px;
}
.xinxi {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}
.xinxi:hover {
  color: #721edc;
}
.biao {
  width: 16px;
  height: 16px;
  background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou.png);
}
.colorBiao {
  background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou1.png) !important;
}
input {
  background: #464646;
  outline: none;
  border: 1px solid #464646;
}
input:focus {
  border: none;
}
.a {
  background-color: #721edc;
}
.xzcxzcxz {
  color: white;
}
</style>
<style>
.personal-bottom-bottom-left .el-collapse-item__content {
  padding-bottom: 0px;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  border-bottom: 0px solid #ebeef5;
}
.personal-bottom-bottom-left .el-collapse-item__content > div {
  text-align: center;
}

.personal-bottom-bottom-left .el-collapse {
  border-top: 0px solid #ebeef5;
  width: 100%;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/component/BangdingXinshoujihao.vue